// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pe-modal-container {
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding: 60px 0;
}

.message-logo {
  text-align: center;
}
.message-logo svg {
  width: 50px;
}
.message-logo svg path {
  fill: #52AD48;
}

.pe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.pe-modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.pe-modal-head {
  margin-top: 20px;
  padding: 5px;
  text-align: center;
}
.pe-modal-head label {
  font-size: 15px;
  line-height: 1.5;
  color: #002f6c;
  margin-bottom: 50px;
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}
.pe-modal-head h2 {
  font-size: 20px;
}

.login-labels {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 12px;
  font-weight: bold;
}

.input-icon-right {
  position: absolute;
  top: 32px;
  right: 8px;
}

.pe-modal-body {
  padding: 0px;
  text-align: center;
}
.pe-modal-body .qr-code-container {
  display: flex;
  justify-content: center;
}
.pe-modal-body .qr-code-container .qr-code-image {
  max-width: 200px;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.pe-modal-body .pe-instructions {
  text-align: center;
  margin-bottom: 20px;
  color: #555;
  font-size: 0.95rem;
}
.pe-modal-body .pe-code-inputs {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.pe-modal-body .pe-code-inputs input {
  width: 40px;
  height: 48px;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.pe-modal-body .pe-code-inputs input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
.pe-modal-body .error-message {
  color: #e53935;
  text-align: center;
  margin-bottom: 16px;
  font-size: 0.875rem;
}
.pe-modal-body .pe-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.pe-modal-body .pe-actions button {
  flex: 1;
  padding: 12px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.pe-modal-body .pe-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.pe-modal-body .pe-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.pe-modal-body .pe-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.pe-modal-body .pe-actions button.verify-button:hover {
  background-color: #002f6c;
}
.pe-modal-body .pe-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

.pe-modal-footer {
  padding: 10px;
  text-align: center;
}
.pe-modal-footer .pe-actions button {
  padding: 5px 25px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.pe-modal-footer .pe-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.pe-modal-footer .pe-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.pe-modal-footer .pe-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.pe-modal-footer .pe-actions button.verify-button:hover {
  background-color: #002f6c;
}
.pe-modal-footer .pe-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

.pe-modal-body {
  padding: 30px 50px;
  text-align: justify;
}

h2 {
  color: #002f6c;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/terms-conditions/terms-conditions-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,WAAA;AACJ;AACI;EACE,aAAA;AACN;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,yCAAA;AADF;AAGE;EACE,UAAA;EACA,mBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAJF;;AAQA;EACE,YAAA;EACA,kBAAA;AALF;AAOE;EACE,aAAA;EACA,uBAAA;AALJ;AAQI;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AANN;AAUE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AARJ;AAWE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AATN;AAWM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AATR;AAcE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAZJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAbJ;AAeI;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAbN;AAeM;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AAbR;AAeQ;EACE,yBAAA;AAbV;AAiBM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAfR;AAiBQ;EACE,yBAAA;AAfV;AAkBQ;EACE,yBAAA;EACA,mBAAA;AAhBV;;AAuBA;EACE,aAAA;EACA,kBAAA;AApBF;AAwBI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAtBN;AAwBM;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AAtBR;AAwBQ;EACE,yBAAA;AAtBV;AA0BM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAxBR;AA0BQ;EACE,yBAAA;AAxBV;AA2BQ;EACE,yBAAA;EACA,mBAAA;AAzBV;;AAgCA;EACE,kBAAA;EACA,mBAAA;AA7BF;;AAiCA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AA9BF","sourcesContent":[".pe-modal-container {\n  background-color: #fff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  padding: 60px 0;\n}\n\n.message-logo{\n  text-align: center;\n\n  svg{\n    width: 50px;\n\n    path {\n      fill: #52AD48;\n    }\n  }\n}\n\n.pe-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.pe-modal-head {\n  margin-top: 20px;\n  padding: 5px;\n  text-align: center;\n\n  label {\n    font-size: 15px;\n    line-height: 1.5;\n    color: #002f6c;\n    margin-bottom: 50px;\n    max-width: 350px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  h2{\n    font-size: 20px;\n  }\n}\n\n.login-labels {\n  color: var(--undp-jtf-btn-dark-color);\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.input-icon-right {\n  position: absolute;\n  top: 32px;\n  right: 8px;\n}\n\n\n.pe-modal-body {\n  padding: 0px;\n  text-align: center;\n\n  .qr-code-container {\n    display: flex;\n    justify-content: center;\n    \n\n    .qr-code-image {\n      max-width: 200px;\n      height: auto;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n    }\n  }\n\n  .pe-instructions {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #555;\n    font-size: 0.95rem;\n  }\n\n  .pe-code-inputs {\n    display: flex;\n    justify-content: center;\n    gap: 8px; \n\n    input {\n      width: 40px;\n      height: 48px;\n      text-align: center;\n      font-size: 1.25rem;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n\n      &:focus {\n        outline: none;\n        border-color: #4a90e2;\n        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n      }\n    }\n  }\n\n  .error-message {\n    color: #e53935;\n    text-align: center;\n    margin-bottom: 16px;\n    font-size: 0.875rem;\n  }\n\n  .pe-actions {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n\n    button {\n      flex: 1;\n      padding: 12px;\n      border-radius: 4px;\n      font-size: 1rem;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &.cancel-button {\n        background-color: #f5f5f5;\n        color: #333;\n        border: 1px solid #ddd;\n\n        &:hover {\n          background-color: #e5e5e5;\n        }\n      }\n\n      &.verify-button {\n        background-color: #002f6c;\n        color: white;\n        border: none;\n\n        &:hover {\n          background-color: #002f6c;\n        }\n\n        &:disabled {\n          background-color: #4e769b;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n\n.pe-modal-footer {\n  padding: 10px;\n  text-align: center;\n  \n  .pe-actions {\n\n    button {\n      padding: 5px 25px;\n      border-radius: 4px;\n      font-size: 1rem;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &.cancel-button {\n        background-color: #f5f5f5;\n        color: #333;\n        border: 1px solid #ddd;\n\n        &:hover {\n          background-color: #e5e5e5;\n        }\n      }\n\n      &.verify-button {\n        background-color: #002f6c;\n        color: white;\n        border: none;\n\n        &:hover {\n          background-color: #002f6c;\n        }\n\n        &:disabled {\n          background-color: #4e769b;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n\n.pe-modal-body {\n  padding: 30px 50px;\n  text-align: justify;\n}\n\n\nh2 {\n  color: #002f6c;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
